import React, { useEffect, useState } from 'react';
import FRONTCARDS from '../utils/frontCardValues';

import 'primeflex/primeflex.css';
import './frontPricing.scss';

import FourOptionSwitch from '../components/FourOptionSwitch';
import FrontPrimeCard from '../components/FrontPrimeCard';

import FrontComparison from '../components/FrontComparison';
import FrontGettingStarted from '../components/FrontGettingStarted';
import FrontBeforeStarted from '../components/FrontBeforeStarted';
import { getData } from '../services/getData';

const period = 'Monthly';

function FrontPricing() {
  const [selected, setSelected] = useState('1');
  const [data, setData] = useState(null);

  useEffect(async () => {
    window.scrollTo(0, 0);
    const res = await getData();
    setData(res);
  }, []);

  return (
    <>
      <div id="frontContainer">
        <div className="container">
          <div className="filters_box grid">
            <div className="locations_box">
              <div className="filters_text text-left mb-3">Number of Locations</div>
              <div id="four-options-switch">
                <FourOptionSwitch onPress={value => setSelected(value)} />
              </div>
            </div>
          </div>
          <div className="grid cards_container">
            {Object.values(FRONTCARDS[selected][period]).map(card => (
              <FrontPrimeCard
                priceId={card.priceId}
                key={card.icon}
                title={card.title}
                description={card.description}
                price={card.price}
                priceText={card.priceText}
                checklistP={card.checklistP}
                buttonLabel={card.buttonLabel}
                icon={card.icon}
                disable={card.disable}
                headerStyle={card.headerStyle}
                priceStyle={card.priceStyle}
                keyFeatures={card.keyFeatures}
                period={selected}
                allCard={Object.values(FRONTCARDS[selected][period])}
              />
            ))}
          </div>
        </div>
      </div>
      <div>
        <FrontComparison data={data} period={period.toLowerCase()} />
      </div>
      <div>
        <FrontGettingStarted />
      </div>
      <div>
        <FrontBeforeStarted />
      </div>
    </>
  );
}

export default FrontPricing;
